import { render, staticRenderFns } from "./appInfo.vue?vue&type=template&id=6f6e327a&scoped=true"
import script from "./appInfo.vue?vue&type=script&lang=js"
export * from "./appInfo.vue?vue&type=script&lang=js"
import style0 from "./appInfo.vue?vue&type=style&index=0&id=6f6e327a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6e327a",
  null
  
)

export default component.exports